import { BigNumber, providers } from 'ethers';
import { formatUnits, parseUnits } from 'ethers/lib/utils';

import { EthereumConfig, defaultEthereumConfig } from './config';

export function web3ProviderFrom(endpoint: string, config?: EthereumConfig): any {
  const ethConfig = Object.assign(defaultEthereumConfig, config || {});

  if (endpoint.includes('wss')) {
    return new providers.WebSocketProvider(endpoint);
  }
  return new providers.JsonRpcProvider(endpoint);
}

export function balanceToDecimal(s: string): string {
  return formatUnits(s);
}

export function decimalToBalance(d: string | number, decimals = 18): BigNumber {
  return parseUnits(String(d), decimals);
}
